import { render } from "./AdDocumentViewMainPartTemplate.vue?vue&type=template&id=8c1b5fee&ts=true"
import script from "./AdDocumentViewMainPartTemplate.vue?vue&type=script&lang=ts"
export * from "./AdDocumentViewMainPartTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__